<script lang="ts" setup>
  import { computed, toRef } from 'vue';
  import { useField } from 'vee-validate';
  import RadioGroup from './RadioGroup.vue';
  import type { RadioGroupProps } from './RadioGroup.types';

  type RadioGroupFieldProps = Omit<RadioGroupProps, 'modelValue'> & {
    name: string;
    rules?: (value: string) => string | boolean;
  };

  const props = defineProps<RadioGroupFieldProps>();

  const {
    value: fieldValue,
    errorMessage,
    handleChange,
    meta,
  } = useField<string>(() => props.name, props.rules, {
    label: toRef(props, 'label'),
  });

  const displayError = computed(() =>
    meta.touched ? errorMessage.value : undefined,
  );
</script>

<template>
  <RadioGroup
    :id="id"
    :label="label"
    :name="name"
    :disabled="disabled"
    :disabled-reason="disabledReason"
    :required="required"
    :orientation="orientation"
    :with-gap="withGap"
    :model-value="fieldValue ?? ''"
    :error="displayError"
    @update:model-value="handleChange"
  >
    <slot />
  </RadioGroup>
</template>
